
import { getPublicRouteUrl } from '@nackle/service-urls';

export const fileLoaderURL = getPublicRouteUrl( 'FILE_LOADER' );
export const rosterURL = getPublicRouteUrl( 'ROSTER_PROXY' );
